<template>

  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Validation du PTA</h1>
      <div>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><router-link :to="{ name: 'dashboard' }"><a>Tableau de
                bord</a></router-link></li>
          <li class="breadcrumb-item active" aria-current="page"><router-link
              :to="{ name: 'validationPta' }"><a>Validation</a></router-link></li>
        </ol>
      </div>
    </div>
    <div class="my-2">
      <router-link :to="{ name: 'pta',params: {  annee:anneeRoute } }"><a><i class="fe fe-arrow-left"></i>
          Retour</a></router-link>
    </div>
    <div class="row">
      <div class="col-12 col-sm-12">

        <div class="modal fade" id="validationPta" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
            <div class="modal-content" style="background-color: #f0f0f5!important;">
              <div class="modal-header bg-primary text-white">
                <h6 class="modal-title fw-bold text-uppercase" style="font-size: 16px;">Détails activité PTA - Inscrire
                  ID PTA Secteur
                </h6>
                <button aria-label="Close" class="btn-close text-white" data-bs-dismiss="modal" type="button"><span
                    aria-hidden="true" @click="fermer">×</span></button>
              </div>
              <div class="modal-body">
                <div class="row mb-3">
                  <div class="col-md-3">
                    <div class="card h-100">
                      <div class="card-body alert alert-secondary shadow shadow">
                        <label for="" class="fw-bold">Année : </label>
                        <p class="card-text fw-bold">
                          <i class="fe fe-tag fs-18"></i> {{ info?.idPta?.annee?.annee }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="card h-100">
                      <div class="card-body alert alert-secondary shadow shadow">
                        <label for="" class="fw-bold">Id PTA Interne : </label>
                        <p class="card-text fw-bold">
                          <i class="fe fe-tag fs-18"></i> {{ info?.idPta?.idPtaAsin }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="card h-100">
                      <div class="card-body alert alert-secondary shadow shadow">
                        <label for="" class="fw-bold">Statut Arbitrage : </label>
                        <p class="card-text fw-bold">
                          <i class="fe fe-tag fs-18"></i> {{ info?.idStatutArb?.libStatutArb }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="card h-100">
                      <div class="card-body alert alert-secondary shadow shadow">
                        <label for="" class="fw-bold">Statut : </label>
                        <p class="card-text fw-bold">
                          <i class="fe fe-tag fs-18"></i>{{ info?.idPta?.statutValidation?.libelle }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-sm-4">
                    <label class="form-label">Id PTA Secteur <span class="text-danger">*</span></label>
                    <input type="text" placeholder="Ex(11.1.2)" class="form-control" v-model="info.idPta.idPtaSecteur">
                  </div>

                </div>

              </div>
              <div class="modal-footer">
                <button class="btn btn-primary" data-bs-dismiss="modal"
                  @click="inscrireSecteur(info)">Sauvegarder</button>
                <button class="btn btn-gray" data-bs-dismiss="modal" @click="fermer">Fermer</button>
              </div>
            </div>
          </div>
        </div>


        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label class="form-label">Année <span class="text-danger">*</span></label>
                  <multi-select deselect-label="Sélectionné" select-label="" :options="exercices" @select="selectAnnee"
                    placeholder="Sélectionné " label="annee" track-by="annee" :searchable="true"
                    :custom-label="o => o.annee" v-model="payload.exercice">
                    <template slot="singleLabel" slot-scope="{ option }">
                      <strong> {{ option.annee }}</strong>
                    </template>
                    <span slot="noOptions">
                      <strong>Liste Vide</strong>
                    </span>
                    <span slot="noResult">
                      <strong>Aucun Résultat</strong>
                    </span>
                  </multi-select>


                </div>
              </div>

            </div>

            <hr>
            <div class="table-responsive">
              <div class="my-2 text-end">
                <button class="fw-bold btn btn-primary my-4 text-end" @click="toggleListeNonValidee">
                  {{ nonValider == true ? 'voir la liste validée' : 'Voir la liste non validée' }}
                </button>
              </div>

              <table class="table table-hover table-bordered text-wrap border-bottom mb-0" id="my">
                <thead class="border-top text-white success02">
                  <tr class="fw-bold">
                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('idPta.idPtaAsin')">Id PTA Interne
                    </th>
                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('idPta.idPtaSecteur')">Id PTA
                      Secteur</th>
                    <th class="bg-transparent border-bottom-0 fw-bold" style="width: 9%;"
                      @click="sortBy('idDetail.nomDetail')">
                      Description
                    </th>
                    <th class="bg-transparent border-bottom-0 fw-bold" style="width: 9%;"
                      @click="sortBy('idDetail.dateDebut')">Date
                      Début
                    </th>
                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('idDetail.dateFin')">Date Fin</th>
                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('besoinAe')">Besoin Total AE</th>
                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('besoinCp')">Besoin Total CP</th>
                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('report')">Report</th>
                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('idStatutArb.libStatutArb')">
                      Statut arbitrage
                    </th>
                    <th class="bg-transparent border-bottom-0 fw-bold"
                      @click="sortBy('idPta.statutValidation.libelle')">Statut</th>
                    <th class="bg-transparent border-bottom-0 fw-bold" style="width: 5%;">Actions</th>
                    <th class="bg-transparent border-bottom-0 fw-bold" style="width: 5%;">
                      <div class="form-check">
                        <input class="form-check-input" :disabled="!nonValider" v-model="isCheckAll" type="checkbox"
                          value="" @change="toggleAll($event)" id="allCheck">

                      </div>

                    </th>
                  </tr>
                </thead>

                <tfoot>
                  <tr class="fw-bold bg-light">
                    <td colspan="13"></td>
                  </tr>
                </tfoot>

                <tbody v-if="Object.keys(sortedItems).length > 0" id="myTable1">

                  <!-- Actions -->
                  <template v-for="(actionGroup, actionKey) in sortedItems">

                    <!-- Ligne Action -->
                    <tr class="border-bottom" style="background-color: #d0e6e9;">
                      <td colspan="12" class="fw-bold">{{ actionGroup.action }}</td>
                    </tr>

                    <!-- Projets -->
                    <template v-for="(projetGroup, projetKey) in actionGroup.projets">
                      <tr style="background-color: #e8f1f5;">
                        <td colspan="12" class="ps-4 fw-semibold">{{ projetGroup.projet }}</td>
                      </tr>

                      <!-- Items -->
                      <tr v-for="(item, idx) in projetGroup.items">

                        <td class="text-end">{{ item.idPta?.idPtaAsin }}</td>
                        <td class="text-end">{{ item.idPta?.idPtaSecteur }}</td>
                        <td class="text-end">{{ item.idDetail?.nomDetail }}</td>
                        <td class="text-end">{{ formatDate(item.idDetail?.dateDebut) }}</td>
                        <td class="text-end">{{ formatDate(item.idDetail?.dateFin) }}</td>
                        <td class="text-end">{{ item.besoinAe }}</td>
                        <td class="text-end">{{ item.besoinCp }}</td>
                        <td class="text-end">{{ item.report }}</td>
                        <td class="text-end">{{ item.idStatutArb?.libStatutArb }}</td>
                        <td class="text-end">{{ item.idPta?.statutValidation?.libelle }}</td>
                        <td>
                          <button class="btn text-primary btn-sm" :disabled="!nonValider" @click.prevent="edit(item)"
                            data-bs-toggle="tooltip" title="Inscrit l'ID du pta secteur"
                            data-bs-original-title="Modifier"><span class="fe fe-edit fs-18"></span></button>


                        </td>
                        <td>
                          <div class="form-check">
                            <input class="form-check-input" :disabled="!nonValider" :checked="isChecked(item)"
                              @change="toggleCheck($event, item)" type="checkbox" value="" id="defaultCheck1">

                          </div>
                        </td>
                      </tr>
                    </template>
                  </template>
                </tbody>

                <tbody v-else>
                  <tr class="primary02">
                    <td colspan="13" class="text-center">Aucun cadrage trouvé</td>
                  </tr>
                </tbody>
              </table>

            </div>

            <nav v-if="pageCount > 1" class="mt-2">
              <ul class="pagination justify-content-end">
                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                  <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">&laquo;</a>
                </li>
                <li v-for="page in pageCount" :key="page" class="page-item" :class="{ active: currentPage === page }">
                  <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                </li>
                <li class="page-item" :class="{ disabled: currentPage === pageCount }">
                  <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">&raquo;</a>
                </li>
              </ul>
            </nav>
            <div class="text-center mt-3" v-if="nonValider && sortedItems.length > 0">
              <button type="button" :disabled="sortedItems.length === 0" @click.prevent="validationPta(checkedItems)"
                class="btn btn-outline-success mr-4">
                <i class="fe fe-check-circle"></i> Valider les PTAS</button>
              <!-- <button type="button" @click.prevent="show(listIdValidation)" class="btn btn-outline-danger mr-4"
                                                :disabled="listIdValidation.length === 0">
                                                <i class="fa fa-minus"></i> Rejeter les liquidations</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import $ from 'jquery';
import { mapGetters, mapActions } from 'vuex';
import * as lang from "vuejs-datepicker/src/locale";
export default {
  name: "GenerationPta",
  data() {
    return {anneeRoute:'',
      localItems: [], selectedItem: null, info: { idPta: { idPtaSecteur: '' }, isFromDb: false }, checkedItems: [],
      lang: lang, payload: { currentStep: 1, classeur: null, composante: "" }, pta: { annee: "", dateDebut: "", dateFin: "", description: "", besoinAeBnTtc: 0, besoinAePretTtc: 0, besoinAeDonTtc: 0, besoinAeAntTtc: 0, besoinAeBaTtc: 0, besoinAeTotTtc: 0, besoin_cp_bn_ttc: 0, besoinCpPretTtc: 0, besoinCpDonTtc: 0, besoinCpAntTtc: 0, besoinCpBaTtc: 0, besoinCpTotTtc: 0 },
      save: true, showList: true, notModified: false, choixCompo: false, choixAnnee: false, nonValider: true, isCheckAll: false,
      classeurs: [], composantes: [], exercices: [], typologies: [], lesactivites: [], lestaches: [], ptas: [], activite: null
    }
  },
  computed: {
    ...mapGetters({ items: 'projetPag/list' }),
    fr() {
      return this.lang.fr;
    },
    activeStep() {
      return this.steps[this.payload.currentStep - 1];
    },
    isLastStep() {
      return this.payload.currentStep === this.steps.length;
    },
    filtersItems() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.sortedItems.slice(start, start + this.perPage);
    },
    groupedItems() {
      return this.localItems.reduce((groups, item) => {
        const actionObj = item.idDetail?.idComposante?.idSsProjPag?.idProjetPag?.idAction;
        const projetObj = item.idDetail?.idComposante?.idSsProjPag?.idProjetPag;

        const actionKey = actionObj?.idAction || 'Autre';
        const projetKey = projetObj?.idProjetPag || 'Autre';

        if (!groups[actionKey]) {
          groups[actionKey] = {
            action: actionObj?.libelleAction || 'Autre',
            projets: {}
          };
        }

        if (!groups[actionKey].projets[projetKey]) {
          groups[actionKey].projets[projetKey] = {
            projet: projetObj?.nomProjetPag || 'Autre',
            items: []
          };
        }

        groups[actionKey].projets[projetKey].items.push(item);

        return groups;
      }, {});
    }
    ,
    sortedItems() {
      console.log(this.groupedItems);
      return Object.values(this.groupedItems).sort((a, b) => {
        const aVal = this.resolveSortValue(a);
        const bVal = this.resolveSortValue(b);
        return this.currentSortDir === 'asc'
          ? (aVal > bVal ? 1 : -1)
          : (aVal < bVal ? 1 : -1);
      });
    },

    pageCount() {

      return Math.ceil(this.sortedItems.length / this.perPage);
    },


  },
  watch: {
    imported: {
      immediate: true,
      handler(val) {
        if (val) this.payload.currentStep++;
      },
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions('generationPta', ['all', 'add']),
    isEmpty(value) {
      return value === null || value === '' || (typeof value === 'object' && Object.keys(value).length === 0);
    },
    onSearch(offset) {
      this.$loading(true);
      if (offset > 0) this.option.page = offset - 1;
      this.$router.push({ query: this.option }).catch(() => { });


    },

    getExercices() {
      this.$http.get('/exercice')
        .then(({ data }) => {
          console.log(data);
          console.log(1);
          this.exercices = data;

        });
    },
    selectAnnee() {
      this.$loading(true);
      this.$http.get(`/arbitragePta/pta/annee/${this.payload.exercice.annee}/${this.nonValider}`)
        .then(({ data }) => {
          this.localItems = data;
          console.log(this.localItems)
          this.$loading(false);
        });
    },
    async selectAnnee() {
      try {
        this.$loading(true);
        const response = await this.$http.get(`/arbitragePta/pta/annee/${this.payload.exercice.annee}/${this.nonValider}`);
        this.localItems = response.data;
        console.log(this.localItems);
      } catch (error) {
        console.error('Erreur lors de la récupération des données:', error);
        // Tu peux afficher une alerte ici si tu veux, par exemple avec swal
        // swal('Erreur', 'Impossible de récupérer les données pour cette année', 'error');
      } finally {
        this.$loading(false);
      }
    }
    ,
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    sortBy(column) {
      if (this.currentSort === column) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.currentSort = column;
        this.currentSortDir = 'asc';
      }
    }, toggleAll() {
      this.allExpanded = !this.allExpanded;
      this.selectedItem = this.allExpanded ? 'ALL' : null;
    }, toggleDetail(item) {
      // Si déjà ouvert, fermer ; sinon, ouvrir
      if (this.selectedItem === item) {
        this.selectedItem = null;
      } else {
        this.selectedItem = item;
      }
    }, changePage(page) {
      if (page >= 1 && page <= this.pageCount) {
        this.currentPage = page;
      }
    },
    resolveSortValue(item) {
      const val = item[this.currentSort];
      if (this.currentSort === 'auteur') {
        return item.user?.firstname + ' ' + item.user?.lastname;
      }
      return typeof val === 'string' ? val.toLowerCase() : val;
    }, edit(item) {
      this.info = item;
      if (this.info.idPta.idPtaSecteur) {
        this.info.isFromDb = true;
      }
      $('#validationPta').modal('show');
      this.$loading(false);
    }, toggleCheck(event, item) {
      if (event.target.checked) {
        if (item?.idPta?.idPtaSecteur) {
          // Ajout si coché
          this.checkedItems.push(item);
        }
        else {
          event.target.checked = false;
          swal('warning', 'Veuillez renseigner l\'Id du PTA Secteur ', 'warning');

        }

      } else {
        // Suppression si décoché
        this.checkedItems = this.checkedItems.filter(i => i.id !== item.id);
      }
    },
    isChecked(item) {
      return this.checkedItems.some(i => i.id === item.id);
    },
    toggleAll(event) {
      const allItems = this.getAllItems();

      if (event.target.checked) {
        // Filtrer les items valides (ceux avec idPtaSecteur renseigné)
        const validItems = allItems.filter(item => !!item?.idPta?.idPtaSecteur);
        const invalidItems = allItems.filter(item => !item?.idPta?.idPtaSecteur);

        this.checkedItems = validItems;

        if (invalidItems.length > 0) {
          swal(
            'Attention',
            `${invalidItems.length} élément(s) non sélectionné(s) car l'ID PTA Secteur est manquant.`,
            'warning'
          );
        }
        if (this.checkedItems.length === 0) {
          event.target.checked = false;
          this.isCheckAll = false;
        }

      } else {
        // Tout décocher
        this.checkedItems = [];
      }
    }

    , getAllItems() {
      let items = [];
      for (const actionKey in this.sortedItems) {
        const actionGroup = this.sortedItems[actionKey];
        for (const projetKey in actionGroup.projets) {
          const projetGroup = actionGroup.projets[projetKey];
          items.push(...projetGroup.items);
        }
      }
      return items;
    },
    toggleListeNonValidee() {

      this.nonValider = !this.nonValider;
      this.selectAnnee();



    },
    fermer() {

      if (this.info && this.info.idPta && !this.info.isFromDb) {
        this.info.idPta.idPtaSecteur = '';
      }
      ("#validationPta").hide();
      this.$loading(false);

    }, async validerPtas() {
      try {
        // Filtrer et préparer la liste des ptas à valider
        const ptasliste = this.checkedItems
          .filter(i => i.idPta && i.idPta.idPtaSecteur)
          .map(i => i.idPta);

        console.log(ptasliste);
        this.$loading(true);

        const { data } = await this.$http.put('/pta/valider', ptasliste);

        if (data) {
          await this.selectAnnee();
          swal('Information!', 'La validation a bien été effectuée.', 'success');
          this.onSearch();
          this.checkedItems = [];
        } else {
          swal('Information!', 'La validation n\'a pas pu être effectuée.', 'warning');
        }
      } catch (error) {
        swal('Information!', 'Une erreur est survenue lors de la validation. ' + error, 'error');
        console.error('Une erreur est survenue lors de la validation :', error);
      } finally {
        this.$loading(false);
      }
    },

    validationPta(checkedItems) {
      if (checkedItems.length === 0) {
        swal('Information!', 'Aucune liste à valider.', 'warning');
        return;
      }

      const self = this;

      swal({
        title: "Confirmation",
        text: "Etes-vous sûr de vouloir valider ces PTAS ?",
        type: "warning",
        showCancelButton: true,
        closeOnConfirm: false,
        cancelButtonText: "Annuler",
        confirmButtonText: "Valider",
        confirmButtonColor: "#7db0b2",
        cancelButtonColor: "#FF0000",
        showLoaderOnConfirm: true
      }, function (result) {
        if (result === true) {
          // Appel à la fonction async qui fait la validation
          self.validerPtas();
        } else {
          // L’utilisateur a annulé, rien à faire
        }
      });
    },

    inscrireSecteur(info) {
      const self = this;
      swal({
        title: "Confirmation",
        text: "Etes-vous sûr de vouloir sauvegarder cette information ?",
        type: "warning",
        showCancelButton: true,
        closeOnConfirm: false,
        cancelButtonText: "Annuler",
        confirmButtonText: "Valider",
        confirmButtonColor: "#7db0b2",
        cancelButtonColor: "#FF0000",
        showLoaderOnConfirm: true
      }, function (result) {
        if (result === true) {
          self.$loading(true);
          self.$http.put('/pta/' + info.idPta.id, info.idPta)
            .then(({ data }) => {
              if (data) {
                swal('Information!', 'La sauvegarde a bien été effectuée.', 'success');

              } else {
                swal('Information!', 'La sauvegarde n\'a pas pu être effectuée.', 'warning');
              }
            })
            .catch((error) => {
              swal('Information!', 'Une erreur est survenue lors de la sauvegarde. ' + error, 'error');
              console.error('Une erreur est survenue lors de la sauvegarde :', error);
            })
            .finally(() => {
              self.$loading(false);
            })
        }
      });
    }

  },
  created() {
    this.anneeRoute = this.$route.params.annee;
    this.onSearch()
    this.getExercices()
    this.$http.get('/typologiePta')
      .then(({ data }) => {
        console.log(data);
        console.log(1);
        this.typologies = data;
      });
    this.$loading(false);


  },
}
</script>

<style></style>